"use client";

import { useState } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const [selectedOption, setSelectedOption] = useState("buy");
  const features = ["Rate Negotiation", "Broker Credit Checks", "Billing and Invoicing", "Packet Management"];
  const paymentMethods = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/payment_visa.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/payment_amex.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/payment_paypal.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/payment_mastercard.png"];
  return <section ref={ref} className="relative bg-accent overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-y-0 left-0 w-1/2 bg-cover bg-center opacity-40 transition-transform duration-700 ease-out" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/hero_semi_truck.png)",
      transform: isVisible ? "translateY(0)" : "translateY(4px)"
    }} />

      {}
      <div className={`relative max-w-7xl mx-auto px-6 lg:px-8 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {}
          <div className="text-foreground-dark space-y-6">
            <p className="text-lg font-medium opacity-90">
              Professional Truck Dispatching
            </p>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
              Keep Moving. Stay Profitable.
            </h1>
            <p className="text-xl opacity-90 max-w-xl">
              We handle the logistics so you can focus on the road. Oryx Fleet LLC provides expert dispatching services to maximize your earnings and minimize downtime.
            </p>
          </div>

          {}
          <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
          transitionDelay: "100ms"
        }}>
            <Card className="bg-background shadow-strong hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <CardHeader>
                <CardTitle className="text-2xl">Start Dispatching Today</CardTitle>
                <CardDescription className="text-base">
                  Choose your plan and let us handle the rest.
                </CardDescription>
              </CardHeader>

              <CardContent className="space-y-6">
                {}
                <RadioGroup value={selectedOption} onValueChange={setSelectedOption}>
                  <div className="flex items-center justify-between p-4 border border-border rounded-md hover:bg-muted/30 transition-colors cursor-pointer">
                    <label htmlFor="buy" className="flex items-center gap-3 cursor-pointer flex-1">
                      <RadioGroupItem value="buy" id="buy" />
                      <div>
                        <p className="font-semibold">Flat Fee Commission</p>
                        <p className="text-sm text-muted-foreground">Transparent pricing, no surprises</p>
                      </div>
                    </label>
                  </div>

                  <div className="flex items-center justify-between p-4 border border-border rounded-md hover:bg-muted/30 transition-colors cursor-pointer">
                    <label htmlFor="lease" className="flex items-center gap-3 cursor-pointer flex-1">
                      <RadioGroupItem value="lease" id="lease" />
                      <div>
                        <p className="font-semibold">Percentage-Based</p>
                        <p className="text-sm text-muted-foreground">Scale with your earnings</p>
                      </div>
                    </label>
                  </div>
                </RadioGroup>

                {}
                <Button className="w-full btn-primary text-base py-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0">
                  Get Started
                </Button>

                {}
                <div className="space-y-3 pt-4">
                  {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                      <Check className="size-5 text-muted-dark shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </div>)}
                </div>

                {}
                <div className="flex items-center gap-4 pt-4 flex-wrap">
                  {paymentMethods.map((method, i) => <img key={i} data-index={i} src={method} alt="Payment method" className="h-6 grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300" />)}
                </div>

                {}
                <p className="text-xs text-muted-foreground pt-2">
                  Need help? Contact us at{" "}
                  <Link to="tel:8882188355" className="text-primary hover:underline">
                    (888) 218-8355
                  </Link>
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}